// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:40:23

export default {
  "id": "mage-s-secret",
  "slug": "mage-s-secret",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/656da7021ceb41d2847cfa7d0612061c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/656da7021ceb41d2847cfa7d0612061c/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Mage's Secret",
      "description": "Combine monsters and increase your power by thinking every action. You have to meet monsters, complete more than 100 tasks and learn the secret of the magician.",
      "instructions": "The goal of the game is to unravel the main mystery of the magician by completing more than 100 tasks, fighting and uniting various monsters. Players will have to gradually increase their magical power, thinking about every action and effectively managing resources.",
      "genres": [
        "Merge"
      ],
      "tags": [
        "magic",
        "monster",
        "timekiller",
        "upgrade",
        "zombie"
      ]
    },
    "zh-CN": {
      "title": "法师的秘密",
      "description": "结合怪物，通过思考每一个动作来提升你的力量。你必须遇见怪物，完成超过100个任务，并揭开魔术师的秘密。",
      "instructions": "游戏目标是通过完成超过100个任务、战斗和联合各种怪物来解开魔术师的重大秘密。玩家需要逐渐增强自己的魔法力量，思考每一个动作并有效管理资源。",
      "genres": [
        "合并"
      ],
      "tags": [
        "魔法",
        "怪物",
        "时间杀手",
        "升级",
        "僵尸"
      ]
    },
    "zh-TW": {
      "title": "魔導之謎",
      "description": "結合怪物，透過思考每個行動來增加你的力量。你必須與怪物相遇，完成超過100個任務，並學習到巫師的祕密。",
      "instructions": "遊戲的目標是通過完成超過100個任務、戰鬥並結合各種怪物來揭開魔术師的主要謎團。玩家必須逐漸提升自己的魔法力量，考慮每個行動並有效管理資源。",
      "genres": [
        "合併"
      ],
      "tags": [
        "魔法",
        "怪物",
        "時間消磨者",
        "升級",
        "僵屍"
      ]
    },
    "zh-HK": {
      "title": "魔法之謎",
      "description": "結合魔獸，透過思考每個行動來增加你的力量。你必須遇見魔獸，完成超過100個任務，並學習到魔法師的秘密。",
      "instructions": "遊戲的目標是通過完成超過100個任務，與各種怪物作戰和團結來揭開魔术師的主謎。玩家必須逐漸提升自己的魔法力量，考慮每一個動作，並有效地管理資源。",
      "genres": [
        "合併"
      ],
      "tags": [
        "魔法",
        "怪物",
        "時間殺手",
        "升級",
        "僵屍"
      ]
    },
    "ja": {
      "title": "魔法の秘密",
      "description": "モンスターを組み合わせて、一つ一つの行動を考えてパワーアップしよう。モンスターに出会い、100以上のタスクを完了し、魔術師の秘密を学びましょう。",
      "instructions": "ゲームの目的は、100以上のタスクを完了し、様々なモンスターと戦い、結束することでマジシャンの主要な謎を解き明かすことです。プレイヤーは、それぞれの行動について考えること、魔法の力を徐々に強化すること、資源を効果的に管理することを必要とします。",
      "genres": [
        "合体"
      ],
      "tags": [
        "マジック",
        "モンスター",
        "タイムキラー",
        "アップグレード",
        "ゾンビ"
      ]
    },
    "ko": {
      "title": "마지의 비밀",
      "description": "모험을 통해 몬스터를 결합하고, 각 행동을 생각하며 힘을 극대화하세요. 몬스터를 만나고 100개 이상의 임무를 완료하고 마법사의 비밀을 찾아야 합니다.",
      "instructions": "게임의 목표는 마법사의 주요 비밀을 풀기 위해 100개 이상의 임무를 완료하고, 다양한 몬스터와 싸우며 연합하는 것입니다. 플레이어는 점차 마법력을 증가시키며, 모든 행동을 생각하고 자원을 효과적으로 관리해야 합니다.",
      "genres": [
        "병합"
      ],
      "tags": [
        "마법",
        "몬스터",
        "타임키ラー",
        "업그레이드",
        "자체리"
      ]
    },
    "fr": {
      "title": "Secret du Mage",
      "description": "Combinez les monstres et augmentez votre puissance en réfléchissant à chaque action. Vous devez rencontrer des monstres, accomplir plus de 100 tâches et apprendre le secret du magicien.",
      "instructions": "L'objectif du jeu est de dévoiler le principal mystère du magicien en accomplissant plus de 100 tâches, en combattant et en unissant divers monstres. Les joueurs devront progressivement augmenter leur pouvoir magique, réfléchir à chaque action et gérer efficacement les ressources.",
      "genres": [
        "Fusionner"
      ],
      "tags": [
        "magic - magie\nmonster - monstre\ntimekiller - tue-temps\nupgrade - amélioration\nzombie - zombie"
      ]
    }
  }
};
